import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-standard-section-layout',
  imports: [],
  templateUrl: './standard-section-layout.component.html',
  styleUrl: './standard-section-layout.component.scss',
})
export class StandardSectionLayoutComponent {
  @Input() title?: string;
  @Input() subtitle?: string;
}
